import { ClientReviewTestimonial } from "./ClientReviewTestimonial";

export const Testimonial = () => {

  return (
    <div className=" w-full pt-12">
      <div className="w-full h-full pt-[3rem] pl-[1rem] pr-[1rem]">
        <div className="container">
          <div className="testimonial-decription">

            <div className="w-full ">
              <p className="text-black pb-[1.5rem] text-base leading-[30px] font-primary">
                Our clients are so much satisfied by working with us. The 100%
                satisfaction ratio and tremendous respect showcase the affection
                of clients towards the company. Each client is like a star in
                the constellation, without it the beauty is incomplete.  Let's have a look at what they have to say about their
                experience with BizzDevs.
              </p>

            </div>
          </div>

          <div className="testimonial-slider">
          </div>
        </div>
      </div>
    </div>
  );
};
